<template>
  <div>
    <button
      class="button button-main altcraft__button"
      @click="close">
      Done
    </button>
  </div>
</template>

<script>
export default {
  name: 'AltcraftPopupPushPrompt',

  mounted() {
    window.AKPush.events.on('subscribe', () => {
      this.close();
    });

    window.AKPush.events.on('update_subscription', () => {
      this.close();
    });
  },

  methods: {
    close() {
      this.$emit('close', 'donePush');
    },
  },
};
</script>

<style scoped>
  .altcraft__button {
    padding: 12px;
  }
</style>
